export const orange = {
  50: '{orange.50}',
  100: '{orange.100}',
  200: '{orange.200}',
  300: '{orange.300}',
  400: '{orange.400}',
  500: '#fca311', // Your brand color
  600: '{orange.600}',
  700: '{orange.700}',
  800: '{orange.800}',
  900: '{orange.900}',
  950: '{orange.950}',
};
